import React from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import PersonalizingBanner from 'aria-viewer/tour/components/banners/Personalization/PersonalizingBanner'
import { PersonalizationStatus } from 'aria-viewer/tour/constants/PersonalizationStatus'

const PersonalizingBannerContainer = ({ personalizationStatus, isDeviceMobile }) => {
    return (
        <>
            {personalizationStatus !== PersonalizationStatus.COMPLETE && (
                <PersonalizingBanner status={personalizationStatus} isDeviceMobile={isDeviceMobile} />
            )}
        </>
    )
}

export default connect(mapSelectorsToProps(['personalizationStatus', 'isDeviceMobile']))(PersonalizingBannerContainer)
